import { DateRange } from 'bold-ui'
import { isSameDay } from 'date-fns'
import { isUndefinedOrNull } from 'util/checks'
import { dateAsDdMmYyyy } from 'util/date/formatDate'

export function getPeriodFilterText(period: DateRange, today: Date): string | undefined {
  const startDate = period?.startDate
  const endDate = period?.endDate

  const isStartFilled = !isUndefinedOrNull(startDate)
  const isEndFilled = !isUndefinedOrNull(endDate)

  const isBothFilled = isStartFilled && isEndFilled

  const formattedStart = isSameDay(startDate, today) ? 'hoje' : dateAsDdMmYyyy(startDate)
  const formattedEnd = isSameDay(endDate, today) ? 'hoje' : dateAsDdMmYyyy(endDate)
  const isStartAndEndDateSameDayAndAreToday =
    isBothFilled && isSameDay(startDate, endDate) && isSameDay(startDate, today)

  if (isStartAndEndDateSameDayAndAreToday) {
    return 'Hoje'
  }

  if (isBothFilled) {
    return `${formattedStart} até ${formattedEnd}`.capitalize()
  }

  if (isStartFilled) {
    return `A partir de ${formattedStart}`
  }

  if (isEndFilled) {
    return `Até ${formattedEnd}`
  }
}
